<script lang="ts">
  import clsx from 'clsx';
  import { Link } from '@athena-lib/Link';
  import type { TextLinkProps } from './types';

  const { class: className, ...restProps }: TextLinkProps = $props();
</script>

<Link {...restProps} class={clsx('text-st-blue-600', className)} />
